import { render } from "./HomeDefault.vue?vue&type=template&id=bddf2cf4&scoped=true"
import script from "./HomeDefault.vue?vue&type=script&lang=js"
export * from "./HomeDefault.vue?vue&type=script&lang=js"

import "./HomeDefault.vue?vue&type=style&index=0&id=bddf2cf4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bddf2cf4"]])

export default __exports__